import {PHONE_TYPE, VALIDATIONS, YES_NO} from "../../utils/constants";
import {optionValues, todayEndOfDay} from "../../utils/utils";

export const getFormFields = (formData, states) => {
    let step1Fields = [
        { type: "text", name: "applicationHealthPlanId", label: "Health Plan ID", maxLength: 16 },
        { type: "text", name: "firstName", label: "First Name", isRequired: true, maxLength: 35, valid: VALIDATIONS.String.isName },
        { type: "text", name: "lastName", label: "Last Name", isRequired: true, maxLength: 35, valid: VALIDATIONS.String.isName },
        { type: "text", name: "address", label: "Home Address", isRequired: true, maxLength: 35 },
        { type: "text", name: "city", label: "City", isRequired: true, maxLength: 50 },
        { type: "options", name: "state", label: "State", optionValues: optionValues(states, !formData.state || formData.state === ''), isRequired: true, maxLength: 2, minLength: 2 },
        { type: "number", name: "postalCode", label: "Zip", isRequired: true, minLength: 5, maxLength: 9, valid: VALIDATIONS.Number.isZipCode },
        { type: "date", name: "birthday", label: "Birthdate", isRequired: true, maxValue: todayEndOfDay() },
        { type: "email", name: "email", label: "Email", maxLength: 255, valid: VALIDATIONS.String.isEmail },
        { type: "tel", name: "phone", label: "Phone", isRequired: true, maxLength: 10 },
        { type: "options", name: "phoneType", label: "Phone Type", optionValues: optionValues(PHONE_TYPE, true) },
    ];

    let step2Fields = [
        { type: "textarea", name: "participateReason", label: "Reason You Would Like to Participate", maxLength: 255, showCharCounter: true, valid: VALIDATIONS.String.noSpecialChars },
        { type: "text", name: "deviceWithInternetAccess", label: "Device with Internet Access", maxLength: 16 },
        { type: "text", name: "primaryLanguage", label: "Primary Language", maxLength: 35 },
        { type: "options", name: "needTranslator", label: "Need Translator", optionValues: optionValues(YES_NO, formData.needTranslator === '') },
        { type: "options", name: "needTransportation", label: "Need Transportation", optionValues: optionValues(YES_NO, formData.needTransportation === '') },
        { type: "options", name: "specificAccommodation", label: "Specific Accommodation", optionValues: optionValues(YES_NO, formData.specificAccommodation === '') },
        {
            type: "text", name: "specificAccommodationNeeds", label: "Specific Accommodation Needs", maxLength: 50,
            hidden: true,
            conditional: true,
            dependsOn: 'specificAccommodation',
            dependsValue: ['Y']
        },
        { type: "options", name: "dietaryRestrictionsAccommodation", label: "Dietary Restrictions", optionValues: optionValues(YES_NO, formData.dietaryRestrictionsAccommodation === '') },
        {
            type: "text", name: "dietaryRestrictionsNeeds", label: "Dietary Restrictions Needs", maxLength: 50,
            hidden: true,
            conditional: true,
            dependsOn: 'dietaryRestrictionsAccommodation',
            dependsValue: ['Y']
        },
        { type: "text", name: "emergencyFirstName", label: "Emergency Contact First Name", maxLength: 35 },
        { type: "text", name: "emergencyLastName", label: "Emergency Contact Last Name", maxLength: 35 },
        { type: "text", name: "relationshipEmergency", label: "Emergency Contact Relationship", maxLength: 35 },
        { type: "tel", name: "phoneEmergency", label: "Emergency Contact Phone", maxLength: 10 },
        { type: "options", name: "phoneTypeEmergency", label: "Emergency Contact Phone Type", optionValues: optionValues(PHONE_TYPE, true) },
    ];

    return {
        step1Fields,
        step2Fields
    }
}
